/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import { observer } from 'mobx-react';
import * as React from 'react';
import { IWineClubInputProps } from './wine-club.types';

//==============================================================================
/**
 * WineClubInputDropdown component
 * @extends {React.Component<IWineClubInputProps>}
 */
//==============================================================================
@observer
class WineClubInputDropdown extends React.Component<IWineClubInputProps> {

    //==========================================================================
    // Public Methods
    //==========================================================================

    public render(): JSX.Element {
        return (
            <div className='form-group'>
                <label>
                    {this.props.label}{this.props.required && '*'}
                    <select
                        className='form-control'
                        id={this.props.id}
                        data-group={this.props.group}
                        required={this.props.required}
                        value={this.props.value}
                        onChange={this.props.handleChange}
                    >
                        <option aria-selected={false} disabled={true}>Select</option>
                        {this._renderOptions()}
                    </select>
                </label>
            </div>
        );
    }

    //==========================================================================
    // Private Methods
    //==========================================================================

    // Render dropdown options from array.
    private _renderOptions(): JSX.Element[] {
        const options: string[] | undefined = this.props.options ? this.props.options : [];
        return options.map((option, index) => {
            const isSelected = option === this.props.value;
            return (
                <option
                    key={index}
                    value={option}
                    aria-selected={isSelected}
                >
                    {option}
                </option>
            );
        });
    }
}

export default WineClubInputDropdown;